import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/next-intl/dist/esm/production/navigation/shared/BaseLink.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["Pagination"] */ "/app/src/components/product/Pagination.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ProductListing"] */ "/app/src/components/product/ProductListing.tsx");
